import type { ValueOf } from '@vy/utils';

export const PLAN_CREATION_REASONS = Object.freeze({
  NewPlan: 'NewPlan',
  NewContract: 'NewContract',
  EditContract: 'EditContract',
  AddPhaseToCurrentContract: 'AddPhaseToCurrentContract',
  ReviseContractForRenewal: 'ReviseContractForRenewal',
});

export type PlanCreateReason = ValueOf<typeof PLAN_CREATION_REASONS>;
